import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../mystyle.css'
const Card = ({ film , removeFromCart }) => {
  const navigate = useNavigate();
  const handleBuy = () => {
  navigate("/buy", { state: film });
};
return (
<div style={{textAlign:'center',margin:'auto',marginTop:'10px'}} className="card card-film">
  <img
    style={{ height: "350px", width: "287px" }}
    src={film.img}
    className="card-img-top"
    alt={film.name}
  />
  <div style={{background:'#e7e7e7'}} className="card-body">
    <h4 className="card-title">{film.name}</h4>
  </div>
  <div className='d-flex ali'>
              <button
          className="btn btn-danger"
          onClick={() => removeFromCart(film.id)}
          style={{background:"white",color:'#008cff',textDecoration:"underLine"}}
        >
          Remove
        </button>
        <button className='border border-0 bg-body btn' style={{color:'#008cff',textDecoration:"underLine",textWrap:"nowrap"}}>Buy {film.buy}</button>
  </div>
</div>
);
}

export default Card;